<div class="container">
  @if (parameterService.loading) {
    <lib-frontend-spinner text="Daten werden geladen" />
  } 
  @else 
  { 
    @switch(parameterService.state) 
    { 
      @case (ViewStateEnum.Choosepayment) 
      {
        <app-choosepayment [mehr_text]="mehr_text" />
      } 
      @case (ViewStateEnum.Dopayment) 
      {
        <app-dopayment/>
      } 
      @case (ViewStateEnum.ShowCoupon) 
      {
        <app-coupon/>
      } 
      @case (ViewStateEnum.Ready) 
      {
        <app-ready/>
      } 
      @case (ViewStateEnum.Open) 
      {
        <app-open/>
      } 
      @case (ViewStateEnum.CheckSuccess) 
      {
        <app-checksuccess/>
      }
      @case (ViewStateEnum.ShowAmazon)
      {
        <lib-frontend-amazonpay/>
      }
    } 
  }
</div>
